<template>
    <div>
        <title>操作记录</title>
        <article class="cardArticle">
            <header class="tabHeader">
                <p>
                   <router-link :to="{path:'/OperateRecord'}" class="isActive" v-if="openStoreDefinition==1">定义激活记录</router-link>
                    <router-link :to="{path:'/ActivationRecord'}" >激活记录</router-link>
                    <router-link :to="{path:'/PauseRecord'}" >暂停记录</router-link>
                    <router-link :to="{path:'/ReuseRecord'}">恢复记录</router-link>
                    <router-link :to="{path:'/RecoverRecord'}" v-if="ElementControls('erjimendian')==1">销售回收记录</router-link>
                    <router-link :to="{path:'/SpreadRecordMd'}" v-if="ElementControls('erjimendian')==1">铺券记录</router-link>
                </p>
            </header>
            <main class="cardMain">
                <!--S 检索-->
                <el-form :model="searchRecordForm" inline class="searchForm operateForm">
                    <el-form-item label="关键词">
                        <el-input v-model="searchRecordForm.keyword" clearable placeholder="请输入内容"></el-input>
                    </el-form-item>
                    <el-form-item label="定义激活时间">
                        <el-date-picker v-model="searchRecordForm.outBoundDate" type="daterange" align="right" unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="query">查询</el-button>
                    </el-form-item>
                    <div class="none" :class="{'block':highShow}">
                    </div>
                </el-form>
                <!-- E 检索 -->
                <section>
                    <el-table ref="gsTable" class="comTable recordTable" border v-loading="vloading" :data="cardBatchList"  :maxHeight="tableHeight">
                        <el-table-column fixed label="序号" type="index"></el-table-column>
                        <el-table-column label="定义激活时间" min-width="200" fixed sortable prop="operdate">
                            <template slot-scope="scope">
                                {{dateTime(scope.row.operdate,1)}}
                            </template>
                        </el-table-column>
                        <el-table-column label="定义激活流向" min-width="150" fixed sortable prop="flowname">
                            <template slot-scope="scope">
                                <p class="textHiden"  :title="scope.row.flowname">{{scope.row.flowname ||'--'}}</p>
                            </template>
                        </el-table-column>
                        <el-table-column label="总数" min-width="80" sortable prop="opernum" fixed>
                            <template slot-scope="scope">
                                <router-link :to="{path:'CardRecordTotal',query:{batchcode:scope.row.batchcode,batchNum: scope.row.opernum}}" class="total priceFont"><i class="iconhand"></i>{{scope.row.opernum ||'0'}}</router-link>
                            </template>
                        </el-table-column>
                        <el-table-column label="序列号段" min-width="180" sortable prop="serials">
                            <template slot-scope="scope">
                                <p v-if="scope.row.serials!=null&&scope.row.serials.indexOf(',') == -1" class="serial">
                                    {{scope.row.serials.split('-')[0]}}
                                    <em>~</em>
                                    {{scope.row.serials.split('-')[1]}}
                                </p>

                                <div v-else-if="scope.row.serials!=null&&scope.row.serials.indexOf(',') != -1&&scope.row.serials.split(',').length>1" class="serialWrap">
                                    <el-popover placement="bottom" width="350" trigger="hover">
                                        <div class="serialPop">
                                            <ul class="flexAro">
                                                <li v-for="(item,index) in scope.row.serials.split(',')" :key="index">
                                                    {{item}}
                                                </li>
                                            </ul>
                                        </div>
                                        <a class="checkSerial" slot="reference">查看序列号段</a>
                                    </el-popover>
                                </div>
                                <div v-else>--</div>
                            </template>
                        </el-table-column>
                        <el-table-column label="券卡用途" sortable prop="carduse" min-width="100">
                            <template slot-scope="scope">
                                {{scope.row.carduse | cardPurposeFilter}}
                            </template>
                        </el-table-column>
                        <el-table-column label="定义类型" sortable prop="deftype" min-width="180">
                            <template slot-scope="scope">
                                {{scope.row.deftype | cardTypeFilter}}
                            </template>
                        </el-table-column>
                        <el-table-column label="专区数量" sortable prop="selzones" min-width="100">
                            <template slot-scope="scope">
                                <em class="priceFont">{{scope.row.selzones||'--'}}</em>
                            </template>
                        </el-table-column>
                        <el-table-column label="共可选择商品数" sortable prop="selnum" min-width="200">
                            <template slot-scope="scope">
                                <p class="flexUpDownCenter">
                                    <template >
                                        <span class="priceFont pr10" >{{scope.row.selnum|| '--'}}</span>
                                    </template>
                                </p>
                            </template>
                        </el-table-column>
                        <el-table-column label="可使用次数" sortable prop="usenum" min-width="120">
                            <template slot-scope="scope">
                                <em class="priceFont">{{scope.row.usenum|| '0'}}</em>
                            </template>
                        </el-table-column>
                        <el-table-column label="券卡类型" sortable prop="cardkind" min-width="100">
                            <template slot-scope="scope">
                                <em class="textHiden" :title="scope.row.cardkind">{{scope.row.cardkind || '--'}}</em>
                            </template>
                        </el-table-column>
                        <el-table-column label="券卡面值(￥)" sortable prop="cardprice" min-width="125">
                            <template slot-scope="scope">
                                <em class="priceFont">{{scope.row.cardprice | formatAmount}}</em>
                            </template>
                        </el-table-column>
                        <el-table-column label="券卡售价(￥)" sortable prop="cardsmallprice" min-width="125">
                            <template slot-scope="scope">
                                <em class="priceFont">{{scope.row.cardsmallprice | formatAmount}}</em>
                            </template>
                        </el-table-column>
                        <el-table-column label="有效期" sortable prop="startvaldate" min-width="120">
                            <template slot-scope="scope">
                                 <p class="serial" v-if="scope.row.startvaldate">
                                      {{dateTime(scope.row.startvaldate)}}
                                    <em>~</em>
                                      {{dateTime(scope.row.endvaldate)}}
                                </p>
                                <p class="serial" v-else>
                                      长期有效
                                </p>
                            </template>
                        </el-table-column>
                        <el-table-column label="客服备注" min-width="150">
                            <template slot-scope="scope">
                                <p class="textHiden" :title="scope.row.sermemo">{{scope.row.sermemo || '--'}}</p>
                            </template>
                        </el-table-column>
                        <el-table-column label="备注" min-width="150">
                            <template slot-scope="scope">
                                <p class="textHiden" :title="scope.row.memo">{{scope.row.memo || '--'}}</p>
                            </template>
                        </el-table-column>
                        <el-table-column label="操作" width="120" fixed="right">
                            <template slot-scope="scope">
                                <el-dropdown placement="bottom-start" @command="getCommand" trigger="click">
                                    <span class="el-dropdown-link" @click="allBatchcode(scope.row.batchcode)">
                                    全部操作<i class="el-icon-arrow-down el-icon--right"></i>
                                    </span>
                                    <el-dropdown-menu slot="dropdown">
                                        <el-dropdown-item command="getCoverDetailShow">详情</el-dropdown-item>
                                    </el-dropdown-menu>
                                </el-dropdown>
                            </template>
                        </el-table-column>
                        <template slot="empty" v-if="vloading">
                          <div :class="{noData:vloading}"></div>
                        </template>
                        <template slot="empty" v-else>
                          <div class="noData"><span>暂无数据</span></div>
                        </template>
                    </el-table>
                    <!-- S 暂停、恢复弹框 -->
                    <el-dialog class="comDlog recoverDlog" title="提示" :visible.sync="recoverDialogVisible" append-to-body :close-on-click-modal="false">
                        <p>当前可{{operateTxt}}数量：<i class="pink commonNum">{{num}}</i></p>
                        <p>确定要进行{{operateTxt}}操作吗？</p>
                        <el-input type="textarea" v-model="recoverMemo"  maxlength="100" :placeholder='"输入"+operateTxt+"备注"'></el-input>
                        <span slot="footer" class="dialog-footer">
                            <el-button type="primary" @click="getCoverSuccessShow(true)">确定</el-button>
                            <el-button @click="getRecoverShow(false)">取消</el-button>
                        </span>
                    </el-dialog>
                    <!-- E 暂停、恢复弹框 -->
                    <!-- S 暂停、恢复成功弹框 -->
                    <el-dialog class="comDlog recoverDlog" title="提示" :visible.sync="coverSuccessDialogVisible" append-to-body :close-on-click-modal="false">
                        <div class="flexUpDownCenter coverSuccess">
                            <i class="el-icon-warning"></i>
                            <div>
                                <p>批次成功{{operateTxt}}<i class="pink commonNum">{{batchOtherOper.num}}</i>张券卡</p>
                                <em>对此生成一条{{operateTxt}}记录</em>
                                <em>批次时间为：{{batchOtherOper.foperdate}}</em>
                            </div>
                        </div>
                        <span slot="footer" class="dialog-footer">
                            <el-button type="primary" @click="getCoverSuccessShow(false)">确定</el-button>
                        </span>
                    </el-dialog>
                    <!-- E 暂停、恢复成功弹框 -->
                    <!-- S 修改、出库弹框 -->
                    <el-dialog class="comDlog recoverDlog" title="提示" :visible.sync="coverEditDialogVisible" append-to-body :close-on-click-modal="false">
                        <div class="flexUpDownCenter coverSuccess">
                            <i class="el-icon-warning"></i>
                            <div>
                                <p>当前可{{editTxt}}数量：{{num}}，确定要进行{{editTxt}}操作吗？</p>
                            </div>
                        </div>
                        <span slot="footer" class="dialog-footer">
                            <el-button type="primary" @click="getCoverEdit(true)">确定</el-button>
                            <el-button @click="getCoverEdit(false)">取消</el-button>
                        </span>
                    </el-dialog>
                    <!-- E 修改、出库弹框 -->
                    <!-- S 出库详情弹框 -->
                    <OutDetail  :cardInfo="cardInfo" :outDetailDialogVisible="outDetailDialogVisible"  @closeChild="getCloseOutDetailCld"></OutDetail>
                    <!-- E 出库详情弹框 -->
                    <!-- S 分页 -->
                    <Page :pageTotal="pageTotal" :currentPage="currentPage" :pageSize="pageSize" @nowPageParam="nowPageParam"></Page>
                    <!-- E 分页 -->
                </section>
            </main>
        </article>
    </div>
</template>
<script>
import Api from "@/apis/api.js";
import { mapState, mapActions } from "vuex";
import Vue from 'vue';
export default {
    name:'OperateRecord',
    components: {
      Page: resolve => require(["@/components/common/Page.vue"], resolve),//分页
      OutDetail: resolve => require(["@/components/CardsFolder/OutDetail.vue"], resolve),//出库详情弹框
      PresaleBrandSelect:resolve => require(["@/components/common/PresaleBrandSelect.vue"], resolve),
    },
    data(){
        return{
            openStoreDefinition:0,
			      cardqupd:0,
		      	vloading:false,
            flowList:[],
            storageList:[],
            memberList:[],
            brandInfoList:[],
            types:0,
            num:0,
            cardInfo:'',
            batchcode:'',
            smallpageSize:30,// 条数
            smallcurrentPage:1, // 页数
            smallpageTotal:0,
            pageTotal:0, //总数
            currentPage:1, // 页数
            pageSize:30, // 条数
            cardBatchList:[],
            batchOtherOper:'',
            // 检索表单
            searchRecordForm:{
                keyword:'',//关键词
                outBoundDate:'', //出库日期
                carduse:'',
                deftype:'',
                brandcode:'',
                flowcode:'',
                membercode:'',
                stocode:'',
            },
             //选择时间
            pickerOptions: {
                shortcuts: [{
                    text: '最近一周',
                    onClick(picker) {
                    const end = new Date();
                    const start = new Date();
                    start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                    picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '最近一个月',
                    onClick(picker) {
                    const end = new Date();
                    const start = new Date();
                    start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                    picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '最近三个月',
                    onClick(picker) {
                    const end = new Date();
                    const start = new Date();
                    start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                    picker.$emit('pick', [start, end]);
                    }
                }]
            },
            highShow:false,//是否展示高级筛选
            recoverMemo:'',//回收备注
            recoverDialogVisible:false,//回收弹框
            coverSuccessDialogVisible:false,//回收成功弹框
            outDetailDialogVisible:false,//出库详情弹框
            tableHeight: window.innerHeight*.8, //表格动态高度
            operateTxt:'',//弹框类型文字
            coverEditDialogVisible:false,//修改的弹框
            editTxt:'',//修改、出库文字
            paths:'',
        }
    },
    // ==================================== 计算属性 ====================================
    computed: {
      ...mapState({
        bdis: ({ common }) => common.bdis,
      })
    },
    watch:{
       $route(to,from){
           this.paths = from.name
        },
    },
    activated(){
        setTimeout(()=>{
        if(this.paths=='礼品券卡操作记录总数'){
              this.cardqupd =this.ElementControls('cardqupd')
            this.flowLists();
            this.getlist();
            this.getBrandInfoList();
            this.getCardBatchList();
            //在dom渲染之后
            setTimeout(()=>{
                this.getHeight();
            },200)
        }else{
            this.currentPage=1; // 页数
            this.pageSize=30; // 条数
            this.searchRecordForm.outBoundDate='';
            this.searchRecordForm.keyword='';
            this.cardqupd =this.ElementControls('cardqupd')
            this.flowLists();
            this.getlist();
            this.getBrandInfoList();
            this.getCardBatchList();
            //在dom渲染之后
            setTimeout(()=>{
                this.getHeight();
            },200)
        }
        },100)
    },
    // ==================================== 方法 ====================================
    methods:{
        brandReceive(val) {
        this.searchRecordForm.brandcode = val;
        console.log(val, '预售')
        },
        //查询
        query(){
          this.pageSize =30;
          this.currentPage =1;
          this.$refs.gsTable.bodyWrapper.scrollTop = 0;
          this.getCardBatchList();
        },
        // 分页
        nowPageParam(val,vals){
          this.pageSize = val;
          this.currentPage = vals;
          this.$refs.gsTable.bodyWrapper.scrollTop = 0;
          this.getCardBatchList();
        },
        allBatchcode(batchcode){
          this.recoverMemo = '';
          this.batchcode = batchcode;
        },
        // 下拉菜单事件
        getCommand(command){
          this.types= command;
          if(command == 'getCoverDetailShow'){
              this.getCoverDetailShow();
              return
          }
          Api.GET_OPERNUM({batchcode:this.batchcode,opertype:command,codetype:0}).then(res =>{
            if(res.data.status=="200"){
                  if(res.data.data>0){
                    this.num = res.data.data;
                    // 详情
                   if(command == "4"){
                      // 回收
                      this.getRecoverShow('回收');
                  }else if(command == "2"){
                      // 暂停
                      this.getRecoverShow('暂停');
                  }else if(command == "3"){
                      // 暂停
                      this.getRecoverShow('恢复');
                  }else if(command == "11"){
                      this.editTxt = '修改';
                      this.coverEditDialogVisible = true;
                  } else if(command == "0"){
                    this.editTxt = '出库';
                    this.coverEditDialogVisible = true;
                  }
               }else{
                 this.num = 0;
                 this.$message.error('当前批次没有可操作的券卡！');
               }
            }
          })
        },
        // 回收、暂停、恢复
        getRecoverShow(val) {
            if(val != false){
                this.operateTxt = val;
                this.recoverDialogVisible = true;
            }else{
                this.recoverDialogVisible = false;
            }
        },
        // 修改
        getCoverEdit(val){
          this.coverEditDialogVisible = false;
            if(val == false){
                this.coverEditDialogVisible = false;
            }else if(this.editTxt == '修改'){
                this.$router.push({
                    path: "/CardsEdit",
                    name:'券卡修改',
                    params:{num:this.num},
                    query:{batchcode:this.batchcode}
                });
            }else if(this.editTxt == '出库'){
                this.$router.push({
                    path: "/CardsRecordOut",
                    name:'券卡记录出库',
                    params:{num:this.num},
                    query:{batchcode:this.batchcode}
                });
            }
        },
        // 回收成功
        getCoverSuccessShow(val){
            if(val==false){
               this.recoverDialogVisible = false;
               this.coverSuccessDialogVisible = val;
               return
            }
            let param = {
                  batchcode:this.batchcode,
                  memo:this.recoverMemo,
                  cardmedium:0
            }
            if(this.types==2||this.types==3){
               Vue.set(param, 'opertype',this.types)
              Api.BATCHOTHEROPER(param).then(res =>{
                  if(res.data.status=="200"){
                    this.batchOtherOper = res.data.data;
                    this.recoverDialogVisible = false;
                    this.coverSuccessDialogVisible = val;
                  }else{
                    this.$message.error(res.data.message);
                  }
              })
            }
            if(this.types==4){
              Api.CARDBATCHRECYCLE(param).then(res =>{
                  if(res.data.status=="200"){
                    this.batchOtherOper = res.data.data;
                    this.recoverDialogVisible = false;
                    this.coverSuccessDialogVisible = val;
                  }else{
                    this.$message.error(res.data.message);
                  }
              })
            }
        },
        // 打开出库详情弹框
        getCoverDetailShow(){
           Api.GET_CARDBATCHDETAIL({batchcode:this.batchcode}).then(res=>{
            if(res.data.status=="200"){
                this.cardInfo = res.data.data;
                this.outDetailDialogVisible = true;
            }else{
              this.$message.error(res.data.message)
            }
          })
        },
        // 关闭出库详情弹框
        getCloseOutDetailCld(){
            this.outDetailDialogVisible = false;
        },
        //动态获取表格高度
        getHeight() {
            let tbHeight = this.$refs.gsTable.$el.offsetTop; //顶部检索条件占据的高度
            //console.log('表格距离顶部高度',tbHeight,'可视区高度',window.innerHeight)
            this.tableHeight = window.innerHeight - tbHeight - 125;
        },
        // 批次列表查询
        getCardBatchList(){
					this.vloading = true;
          let param = {
               codetype:0,
               opertype:0,
              //  deftype:1,
               cardmedium:0,
               startvaldate:this.searchRecordForm.outBoundDate?this.dateTime(this.searchRecordForm.outBoundDate[0]):'',
               endvaldate:this.searchRecordForm.outBoundDate?this.dateTime(this.searchRecordForm.outBoundDate[1]):'',
               keyword:this.searchRecordForm.keyword,
               cardcategory:this.searchRecordForm.cardcategory?0:'',//是否是按量提货卡
              //  carduse:this.searchRecordForm.carduse,
              //  deftype:this.searchRecordForm.deftype,
              //  brandcode:this.searchRecordForm.brandcode,
              //  flowcode:this.searchRecordForm.flowcode,
              //  membercode:this.searchRecordForm.membercode,
              //  stocode:this.searchRecordForm.stocode,
               pageparam:{
                    pagesize: this.pageSize, //每页条数
                    currentpage: this.currentPage, //当前页数
              }
          }
          Api.GET_CARDBATCHLIST(param).then(res =>{
              this.toTableTop('gsTable');
              if(res.data.status=="200"){
								this.vloading = false;
                 this.cardBatchList = res.data.data;
                 this.pageTotal = res.data.pagebean.totalnum;
              }else {
                 this.pageTotal =0;
                 this.cardBatchList =[];
              }
          })
        },
        //预售品牌
        getBrandInfoList(){
         Api.GET_BRANDINFOLIST().then(res =>{
           if(res.data.status=="200"){
              this.brandInfoList = res.data.data;
           }
         })
        },
        smallhandleCurrentChange(val){
          this.smallcurrentPage = val;
          this.getMemberList()
        },
        // 会员
        getMemberList(){
          let param ={
               pageparam:{
                    pagesize: this.smallpageSize, //每页条数
                    currentpage: this.smallcurrentPage, //当前页数
              }
          }
           Api.GET_MEMBERLIST(param).then(res =>{
             if(res.data.status=="200"){
               this.memberList = res.data.data;
               this.smallpageTotal = res.data.pagebean.totalnum;
             }else{
                this.memberList =[];
                this.smallpageTotal =0;
             }
           })
        },
        // 仓库
        getlist(){
          Api.GET_STORAGELIST({type:'0,1'}).then(res =>{
            if(res.data.status=="200"){
              this.storageList = res.data.data;
            }
          })
        },
        // 流向
        flowLists(){
          let param = {

          }
          Api.GET_FLOWLIST(param).then(res =>{
            if(res.data.status=="200"){
              this.flowList = res.data.data;
             }
          })
        }
    },
    // ==================================== 生命周期 ====================================
    mounted () {
       this.openStoreDefinition = this.ElementControls('openStoreDefinition')
		   this.cardqupd =this.ElementControls('cardqupd')
        this.flowLists();
        this.getlist();
        this.getMemberList();
        this.getBrandInfoList();
        this.getCardBatchList();
        //在dom渲染之后
        setTimeout(()=>{
            this.getHeight();
        },200)
    },
    created() {
        //页面浏览器视窗变化绑定resize事件
        window.addEventListener("resize", this.getHeight);
    },
    destroyed(){
        window.removeEventListener('resize', this.getHeight); //销毁监听浏览器视窗变化
    }
}
</script>
<style scoped>
	.noData{
		height: 400px;
	}
.cardArticle{
    position: relative;
    padding: 84px 20px 20px 20px;
    height: calc(100% - 169px);
}
/* S 检索 */
.simpleSearch{
    line-height: 40px;
    color: var(--main-color);
    cursor: pointer;
    white-space: nowrap;
}
.operateForm{
    margin-bottom: 10px;
}
.operateForm>>>.el-form-item{
    margin-bottom: 10px;
}
.none{
    display: none;
}
.block{
    display: block;
}
/* E 检索 */
/* S 表格 */
.total{
    line-height: 20px;
    font-weight: bold;
}
.total i{
    font-size: 20px;
    margin-right: 5px;
    vertical-align: text-bottom;
}
.serial em{
    display: block;
    margin-left: 26px;
}
.serialPop ul{
    -o-flex-wrap: wrap;
    -ms-flex-wrap: wrap;
    -moz-flex-wrap: wrap;
    -webkit-flex-wrap: wrap;
    flex-wrap: wrap;
    max-height: 120px;
    overflow-y: auto;
}
.serialPop ul li{
    color: #666;
    line-height: 28px;
}
.recordTable .el-dropdown-link{
    cursor: pointer;
    color: var(--main-color);
}
.recordTable>>>.el-table__fixed-right-patch{
    background-color: #F5F7FA;
}
.recordTable>>>td:nth-child(5) .cell{
    overflow: initial;
}
.serialWrap{
    position: relative;
}
.serialPop{
    /* position: absolute; */
    /* top: 30px; */
    width: 370px;
    background: #fff;
    /* display: none; */
    z-index: 1;
    /* border: 1px solid #E4E7ED; */
    /* -o-box-shadow:0px 2px 12px 0px rgba(0, 0, 0, 0.1);
    -ms-box-shadow:0px 2px 12px 0px rgba(0, 0, 0, 0.1);
    -moz-box-shadow:0px 2px 12px 0px rgba(0, 0, 0, 0.1);
    -webkit-box-shadow:0px 2px 12px 0px rgba(0, 0, 0, 0.1);
    box-shadow:0px 2px 12px 0px rgba(0, 0, 0, 0.1); */
    padding: 10px 0;
}
.serialWrap:hover .serialPop{
    display: block;
}
.serialWrap:hover a{
    color: var(--main-color);
}
/* E 表格 */
/* S 回收弹框 */
.recoverDlog>>>.el-dialog{
    width: 420px;
}
.recoverDlog>>>.el-dialog__footer{
    box-shadow: none;
    margin-bottom: 5px;
}
.recoverDlog>>>.el-button{
    padding: 8px 15px;
}
.recoverDlog p{
    color: #666;
    line-height: 25px;
}
.recoverDlog>>>.el-dialog__body{
    padding: 13px 20px 11px 20px;
}
.recoverDlog>>>.el-textarea{
    margin-top: 15px;
}
.pink{
    color: #F7615E;
    font-weight: bold;
    margin: 0 5px;
}
.el-icon-warning{
    color: #F2962C;
    font-size: 24px;
    margin-right: 15px;
}
.coverSuccess p{
    margin-bottom: 5px;
}
.coverSuccess em{
    display: block;
    line-height: 1.5;
}
/* E 回收弹框 */
.el-scrollbar__view {position:relative;padding-bottom:40px;}
.el-scrollbar__view >>> .el-pagination   {position:absolute; bottom:0;left:0;width:100%;}
.pr10 {padding-right:10px;white-space: nowrap;}
</style>



// WEBPACK FOOTER //
// src/views/CardsFolder/CardsGift/CardRecord/OperateRecord.vue